export const LOCAL_STORAGE_KEYS = {
  POSTHOG_DISTINCT_ID: `ph_${process.env.NEXT_PUBLIC_POSTHOG_API_KEY}_posthog`,
  EXPERIMENTS: 'experiments',
} as const;

export const COOKIE_NAMES = {
  BOOTSTRAP_EXPERIMENTS: 'bootstrapExperiments',
} as const;

export const TIMEOUT_DURATIONS = {
  DEFAULT_REQUEST: 5000,
} as const;

export const POSTHOG_CONFIG = {
  HOST: 'https://eu.i.posthog.com',
  EXPERIMENT_PREFIX: 'experiment',
  DECIDE_ENDPOINT: '/decide?v=3',
  CAPTURE_ENDPOINT: '/capture/',
} as const;

export const DEFAULT_VALUES = {
  PROJECT_NAME: 'web',
  FALLBACK_DISTINCT_ID: 'web_middleware_logger',
} as const;
